// Izvoz povijesne kartice osnovnog sredstva u Excel.
//
// Isti raspored kao pdf. Iznosi su brojevi (ne tekst) da se mogu zbrajati.
// Napomena: !freeze se u ovoj verziji xlsx-a tiho preskace, pa ga ne koristimo.

import XLSX from 'xlsx'
import dayjs from 'dayjs'
import {num, naziviFirme, formatirajBrojeve} from './mainLedgerXlsx'
import {podaciSredstvaTekst} from './llaKarticaPodaci'

const iznos = (v) => Math.round(num(v) * 100) / 100

const KOLONE = [
  {head: 'Godina', w: 34},
  {head: 'Nabavna vrijednost', w: 17},
  {head: 'Ispravak početak', w: 17},
  {head: 'Amortizacija godine', w: 17},
  {head: 'Ispravak kraj', w: 17},
  {head: 'Neto kraj godine', w: 17},
  {head: 'Stopa %', w: 9},
  {head: 'Napomena', w: 70}
]

const stopaVrijednost = (g) => {
  if (g.nemaZapisa) { return '' }
  if (g.stopa !== null && g.stopa !== undefined) { return iznos(g.stopa) }
  return String(g.stopaMin).replace('.', ',') + '–' + String(g.stopaMax).replace('.', ',')
}

const napomenaTekst = (napomene, upozorenja) =>
  napomene.concat(upozorenja.map(u => '! ' + u)).join('; ')

const prazan = (v) => (v === null || v === undefined ? null : iznos(v))
const izvorTemeljnice = (t) => 'Temeljnica OS ' + t.bookID + ' · ' + t.datum + ' (id ' + t.id + ')'

// Redovi detalja knjizenja godine: [godina, izvor, stavka, konto, naziv konta, duguje, potrazuje, napomena]
export const redoviKnjizenja = (g) => {
  const z = g.knjizenje
  if (!z) { return [] }
  const redovi = []
  ;(z.temeljnice || []).forEach(t => {
    t.stavke.forEach(x => {
      redovi.push([g.godina, izvorTemeljnice(t), x.opis, x.konto, x.nazivKonta, iznos(x.duguje), iznos(x.potrazuje), z.nesigurnaVeza ? 'veza po nazivu nije sigurna' : ''])
    })
  })
  if (!(z.temeljnice || []).length) {
    redovi.push([g.godina, 'nema temeljnice u ovoj godini', '', '', '', null, null, ''])
  }
  ;(z.stavke || []).forEach(x => {
    redovi.push([g.godina, 'Zapis sredstva', x.stavka, x.konto, x.nazivKonta, prazan(x.duguje), prazan(x.potrazuje), x.napomena])
  })
  return redovi
}

const KOLONE_KNJIZENJA = [
  {head: 'Godina', w: 8}, {head: 'Izvor', w: 40}, {head: 'Stavka / opis', w: 40}, {head: 'Konto', w: 10},
  {head: 'Naziv konta', w: 44}, {head: 'Duguje', w: 14}, {head: 'Potražuje', w: 14}, {head: 'Napomena', w: 50}
]

export const exportLlaKarticaXlsx = (ctx) => {
  const k = ctx.kartica || {godine: []}
  const company = ctx.company || {}
  const trenutak = dayjs().format('DD.MM.YYYY HH:mm')
  const prazno = KOLONE.map(() => null)
  const firma = naziviFirme(company)
  const aoa = []
  aoa.push(['Povijesna kartica osnovnog sredstva'].concat(prazno.slice(1)))
  aoa.push([(k.naziv || '') + ' · Šifra int. ' + (k.llaID || '') + ' · AOP oznaka ' + (k.llaCode || '')].concat(prazno.slice(1)))
  aoa.push([firma[0]].concat(prazno.slice(1)))
  aoa.push([firma[1]].concat(prazno.slice(1)))
  aoa.push(['EUR   godine ' + k.prvaGodina + ' – ' + k.tekucaGodina + '   Ispis ' + trenutak].concat(prazno.slice(1)))
  if (podaciSredstvaTekst(k)) { aoa.push([podaciSredstvaTekst(k)].concat(prazno.slice(1))) }
  aoa.push(prazno.slice())
  const redakNaslova = aoa.length
  aoa.push(KOLONE.map(c => c.head))

  let imaDetalj = false
  k.godine.forEach(g => {
    aoa.push([
      g.godina + (g.tekuca ? ' (tekuća)' : ''),
      g.nemaZapisa ? null : iznos(g.nabavna),
      g.nemaZapisa ? null : iznos(g.ispravakPocetak),
      g.nemaZapisa ? null : iznos(g.amortizacija),
      g.nemaZapisa ? null : iznos(g.ispravakKraj),
      g.nemaZapisa ? null : iznos(g.netoKraj),
      stopaVrijednost(g),
      napomenaTekst(g.napomene, g.upozorenja)
    ])
    if ((ctx.otvorene || []).indexOf(g.godina) !== -1 && g.knjizenje) {
      aoa.push(['   Knjiženje u godini ' + g.godina + ' – izvor', 'Konto', 'Naziv konta', 'Duguje', 'Potražuje', 'Stavka / opis', '', 'Napomena'])
      redoviKnjizenja(g).forEach(r => {
        // u glavnom listu: [izvor, konto, naziv konta, duguje, potrazuje, stavka, (prazno), napomena] uvuceno ispod godine
        aoa.push(['   ' + r[1], r[3], r[4], r[5], r[6], r[2], null, r[7]])
        imaDetalj = true
      })
    }
  })
  aoa.push(['Zbroj amortizacije kroz sve godine', null, null, iznos(k.ukupnoAmortizacija), null, null, null, null])
  const zadnjiRedak = aoa.length - 1

  const ws = XLSX.utils.aoa_to_sheet(aoa)
  ws['!cols'] = KOLONE.map(c => ({wch: c.w}))
  // s uvucenim redovima detalja filtar bi miješao retke, pa ga tada nema
  if (!imaDetalj) {
    ws['!autofilter'] = {ref: XLSX.utils.encode_range({r: redakNaslova, c: 0}, {r: zadnjiRedak - 1, c: KOLONE.length - 1})}
  }
  formatirajBrojeve(ws, redakNaslova + 1, 1)

  const wb = XLSX.utils.book_new()
  const praznoKnj = KOLONE_KNJIZENJA.map(() => null)
  const aoaKnj = []
  aoaKnj.push(['Knjiženje po godinama: ' + (k.naziv || '') + ' · Šifra int. ' + (k.llaID || '') + ' · AOP oznaka ' + (k.llaCode || '')].concat(praznoKnj.slice(1)))
  if (podaciSredstvaTekst(k)) { aoaKnj.push([podaciSredstvaTekst(k)].concat(praznoKnj.slice(1))) }
  aoaKnj.push(praznoKnj.slice())
  const redakNaslovaKnj = aoaKnj.length
  aoaKnj.push(KOLONE_KNJIZENJA.map(c => c.head))
  k.godine.forEach(g => { redoviKnjizenja(g).forEach(r => aoaKnj.push(r)) })
  const wsKnj = XLSX.utils.aoa_to_sheet(aoaKnj)
  wsKnj['!cols'] = KOLONE_KNJIZENJA.map(c => ({wch: c.w}))
  wsKnj['!autofilter'] = {ref: XLSX.utils.encode_range({r: redakNaslovaKnj, c: 0}, {r: Math.max(aoaKnj.length - 1, redakNaslovaKnj), c: KOLONE_KNJIZENJA.length - 1})}
  formatirajBrojeve(wsKnj, redakNaslovaKnj + 1, 5)
  XLSX.utils.book_append_sheet(wb, ws, 'Kartica ' + String(k.llaID || '').replace(/[:\\/?*[\]]/g, '_').substring(0, 20))
  XLSX.utils.book_append_sheet(wb, wsKnj, 'Knjiženje po godinama')
  XLSX.writeFile(wb, (company.CompanyNameShort || 'Kartica') + '_Sredstvo_' + String(k.llaID || '').replace(/[^\w-]/g, '_') +
    '_' + dayjs().format('DD_MM_YYYY_HHmm') + '.xlsx')
}

export default {exportLlaKarticaXlsx}
